module.exports = __webpack_public_path__ + "static/media/whatsapp.c15e4a68.png";